
import { React, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from "../context/UserContext";
import JWTService from '../services/JWTService';
import { ArrowLeft, Settings, X } from "lucide-react"

const Premium = () => {
    const navigate = useNavigate();

    const { user, loginUser } = useUser(); // Use context

    useEffect(() => {
        if (!user || (user && JWTService.isTokenExpired(user.token))) navigate("/login");

    })

    const handleButtonClick = () => {
        window.open('https://buy.stripe.com/5kAcPU5dd18afn2aEE?client_reference_id=67a56cfbb8da658849a3b125', '_blank');
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center p-8">
            <Link to="/" className="inline-flex items-left text-gray-600 mb-4">
                <ArrowLeft className="w-5 h-5 mr-1" />
                BACK
            </Link>
            <h1 className="text-3xl font-bold mb-6">Unlock unlimited sport avatars!</h1>
            <ul className="mb-6 text-lg">
                <li>🏋️‍♂️ Up to 37 sports avatars</li>
                <li>🔥 Have fun and stay fit!</li>
                <li>😌 No subscription headache</li>
            </ul>
            <button
                onClick={handleButtonClick}
                className="bg-red-500 text-white px-6 py-3 rounded text-lg"
            >
                ✨ GO PREMIUM FOR $19
            </button>
            <p className="mt-4 text-gray-600">One time payment, unlock forever!</p>
        </div>
    );
};

export default Premium;

